// eslint-disable-next-line import/no-unresolved
import { Platform } from "react-native";

const isPWA = Platform.OS === "web";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () => isPWA;
